import React, { Component } from "react";
import ImageHeroContainer from "./../shared/containers/ImageHeroContainer";
import Store from "../../content/Store";
import OuterPrimaryContainer from "../shared/containers/OuterPrimaryContainer";
import contentify from "../../content/Contentify";
import styles from "../../assets/css/modules/health-support/working-body.css";
import { Paths } from "./../../constants/UrlConstants";
import HelpSection from "./../shared/HelpSection";
import NumberStepList from "../shared/groups/NumberStepList";

export class FastTrackAppointments extends Component {
  static content = Store.FastTrackAppointments;
  render() {
    return (
      <div className={styles.workingBody}>
        <OuterPrimaryContainer>
          <ImageHeroContainer
            bgImage={this.props.content.BackgroundDesktopImage}
            bgImageMobile={this.props.content.BackgroundMobileImage}
            bgImageTablet={this.props.content.BackgroundTabletImage}
            bgAlt=""
          >
            {this.props.content.HeroContent}
            {this.props.content.HeroContentPhoneNumbers}
          </ImageHeroContainer>

          <section className={styles.sectionSpacingHelpSection}>
            <h2 className={styles.workingBodyHeading}>
              {this.props.content.StepHeader}
            </h2>
            <NumberStepList>
              {this.props.content.StepGPReferral}
              {this.props.content.StepGiveUsACall}
              {this.props.content.StepAppointmentBooking}
            </NumberStepList>
          </section>

          <section className={styles.sectionSpacingHelpSection}>
            <HelpSection
              HeadingLinkTo={Paths.Help}
              HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
              MoreHelpLinkTo={Paths.Help}
              MoreHelpLinkText={Store.GeneralPages.MoreHelpLinkText}
              HelpSet={this.props.content.HelpSet}
            />
          </section>
        </OuterPrimaryContainer>
      </div>
    );
  }
}
export default contentify(FastTrackAppointments);
